import CouponsContainer from "./CouponsContainer";
import CouponsStore from "./CouponsStore";
export default CouponsStore(CouponsContainer);